import { Card, Title } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import { usePutProjectByProjectIdIssueItemAndIssueIdCommentCommentIdReactionMutation } from "../../../../../../../openapi";
import FoldableSection from "../../../../../../components/FoldableSection/FoldableSection";
import { useAppSelector } from "../../../../../../hooks";
import LocalErrorBoundary from "../../../../../../util/LocalErrorBoundary";
import { useGetProjectQuery } from "../../../../../projectRTK";
import {
  useAddIssueCommentMutation,
  useDeleteIssueCommentMutation,
  useUpdateIssueCommentMutation,
} from "../../../issueRTKLegacy";
import MultiCommentMantine from "./MultiCommentMantine";

type IIssueDiscussionSectionProps = {
  projectId: string;
  issue: IIssueApi;
};

const IssueDiscussionSection = ({ projectId, issue }: IIssueDiscussionSectionProps) => {
  const [addComment, { isLoading: addCommentLoading, error: addCommentError }] = useAddIssueCommentMutation();
  const [deleteComment, { isLoading: deleteCommentLoading, error: deleteCommentError }] =
    useDeleteIssueCommentMutation();
  const [updateComment, { isLoading: updateCommentIsLoading, error: updateCommentError }] =
    useUpdateIssueCommentMutation();
  const [reactToComment] = usePutProjectByProjectIdIssueItemAndIssueIdCommentCommentIdReactionMutation();

  const { data: project, isLoading: projectLoading } = useGetProjectQuery(projectId);
  const user = useAppSelector((state) => state.globalReducer.user);

  return (
    <FoldableSection storageKey="issue-modal-discussion">
      <FoldableSection.Header>
        <Title order={6}>Diskusjon</Title>
      </FoldableSection.Header>
      <FoldableSection.Body>
        <LocalErrorBoundary id="IssueDiscussionSection">
          <Card w="100%" bg="#f8f9fa" bd="1px solid var(--mantine-color-warmgray-2)">
            <MultiCommentMantine
              isLoading={addCommentLoading || deleteCommentLoading || updateCommentIsLoading || projectLoading}
              showCancelButton={false}
              members={project?.members}
              comments={issue.comments}
              onAdd={async (text, metadata) => {
                await addComment({ projectId, issueId: issue._id, text, metadata });
              }}
              onDelete={async (_id) => {
                await deleteComment({ projectId, issueId: issue._id, commentId: _id });
              }}
              onUpdate={async (_id, text, metadata) => {
                await updateComment({ projectId, issueId: issue._id, commentId: _id, text, metadata });
              }}
              onReact={async (commentId, emoji) => {
                await reactToComment({ projectId, issueId: issue._id, commentId, body: { emoji } });
              }}
              currentUserId={user?._id}
              loggedInUser={user}
            />
          </Card>
        </LocalErrorBoundary>
      </FoldableSection.Body>
    </FoldableSection>
  );
};

export default IssueDiscussionSection;
